import { DRAW_MODE_NAMES } from 'shared/stores/annotations/consts';
import { actionProvider, installable } from 'shared/stores/core/decorators';

const DRAW_MODE_LOCK = {lockOwner: 'us:conferencing', displayKey: 'conferencing.title', modes: DRAW_MODE_NAMES};

@installable
@actionProvider
export class ConferencingActions {
  USCOPE_BIND_EVENTS ({dispatch}, uScope) {
    uScope.events.on('us:conferencing:start', () => {
      dispatch('LOCK_DRAW_MODES', DRAW_MODE_LOCK);
      dispatch('HIDE_DRAWING_TOOLS');
    });

    uScope.events.on('us:conferencing:finish', () => {
      // TODO: Triggering "lock" makes no sense here; if something else is preventing annotations then it should
      // TODO:    engage a separate lock. The only thing we should be doing in this class is adding and removing
      // TODO:    our own lock.
      // TODO: The "canAnnotate()" method is here for conferencing, which is redundant. Move all logic here.
      const action = uScope.canAnnotate() ? 'UNLOCK_DRAW_MODES' : 'LOCK_DRAW_MODES';
      dispatch(action, DRAW_MODE_LOCK);
    });
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/conferencing/ConferencingActions.js